import cx from "classnames";

import Box from "ds/components/Box";
import useMainNavigationPulseAnimation from "components/MainNavigation/hooks/usePulseAnimation";

import styles from "./styles.module.css";

const MainNavigationGradient = () => {
  const isPulsing = useMainNavigationPulseAnimation();

  return <Box className={cx(styles.gradient, { [styles.pulse]: isPulsing })}>&nbsp;</Box>;
};

export default MainNavigationGradient;
